export default {
    companies: JSON.parse(localStorage.getItem("companies")) || null,
    products: [],
    permissionsEt: [],
    etProduct: {},
    name_module: '',
    filter: {
        company_id: null,
        order: null,
        product: null,
        component: null,
        fabricante: null,
        comment: null,
        page: 1,
        per_page: 10,
        sortBy: 'id',
        sort: 'DESC',
    },
    loading_data_select: false,
    manufacturers_filter: [],
}



